export default __webpack_public_path__ + "static/media/warning--steep-ascent--g3.ac4d27d9.png";